import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { motion } from 'framer-motion';

const DatenschutzPage = () => (
  <div className="bg-[#F8F5F0] min-h-screen">
    <Navbar />
    <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-36 pb-24">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        data-testid="datenschutz-page"
      >
        <span className="text-[11px] tracking-[0.22em] uppercase text-[#8B7355] font-outfit mb-3 block">
          Rechtliches
        </span>
        <h1 className="font-cormorant text-4xl md:text-5xl text-[#2A2A2A] font-medium mb-12">
          Datenschutzerklärung
        </h1>

        <div className="font-outfit text-[#2A2A2A]/80 leading-relaxed space-y-8 text-sm">
          <section>
            <h2 className="font-cormorant text-2xl text-[#2A2A2A] font-semibold mb-4">1. Verantwortlicher</h2>
            <div className="bg-white border border-[#EDE8E0] p-6 space-y-1">
              <p className="font-semibold text-[#2A2A2A]">Schulz & Gojowy GbR</p>
              <p>An der Schneise 57 · 13503 Berlin-Heiligensee</p>
              <p>Telefon: 030 / 4 31 15 80</p>
              <p>E-Mail: gardinenatelier@ausheiligensee.de</p>
            </div>
          </section>

          <section>
            <h2 className="font-cormorant text-2xl text-[#2A2A2A] font-semibold mb-4">2. Erhebung und Speicherung personenbezogener Daten</h2>
            <div className="bg-white border border-[#EDE8E0] p-6 space-y-4 text-[#2A2A2A]/65">
              <p>
                Beim Besuch unserer Website werden durch den auf Ihrem Endgerät zum Einsatz kommenden Browser automatisch Informationen an den Server unserer Website gesendet. Diese Informationen werden temporär in einem sogenannten Logfile gespeichert.
              </p>
              <p>Folgende Informationen werden dabei ohne Ihr Zutun erfasst und bis zur automatisierten Löschung gespeichert:</p>
              <ul className="list-disc list-inside space-y-1 ml-2">
                <li>IP-Adresse des anfragenden Rechners</li>
                <li>Datum und Uhrzeit des Zugriffs</li>
                <li>Name und URL der abgerufenen Datei</li>
                <li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
                <li>Verwendeter Browser und ggf. das Betriebssystem Ihres Rechners</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="font-cormorant text-2xl text-[#2A2A2A] font-semibold mb-4">3. Kontaktformular</h2>
            <div className="bg-white border border-[#EDE8E0] p-6 text-[#2A2A2A]/65">
              <p>
                Bei Ihrer Kontaktaufnahme mit uns per Kontaktformular oder E-Mail werden die von Ihnen mitgeteilten Daten (Ihre E-Mail-Adresse, ggf. Ihr Name und Ihre Telefonnummer) von uns gespeichert, um Ihre Fragen zu beantworten. Die in diesem Zusammenhang anfallenden Daten löschen wir, nachdem die Speicherung nicht mehr erforderlich ist, oder schränken die Verarbeitung ein, falls gesetzliche Aufbewahrungspflichten bestehen.
              </p>
            </div>
          </section>

          <section>
            <h2 className="font-cormorant text-2xl text-[#2A2A2A] font-semibold mb-4">4. Cookies</h2>
            <div className="bg-white border border-[#EDE8E0] p-6 text-[#2A2A2A]/65 space-y-3">
              <p>
                Wir setzen auf unserer Website Cookies ein. Hierbei handelt es sich um kleine Dateien, die Ihr Browser automatisch erstellt und die auf Ihrem Endgerät gespeichert werden, wenn Sie unsere Seite besuchen.
              </p>
              <p>
                Wir verwenden ausschließlich technisch notwendige Cookies (z. B. zur Speicherung Ihrer Cookie-Einstellungen). Diese Cookies werden ohne Ihre ausdrückliche Zustimmung gesetzt, da sie für den Betrieb der Website erforderlich sind.
              </p>
              <p>
                Sie können der Setzung von Cookies jederzeit mittels einer entsprechenden Einstellung des genutzten Internetbrowsers widersprechen und bereits gesetzte Cookies löschen.
              </p>
            </div>
          </section>

          <section>
            <h2 className="font-cormorant text-2xl text-[#2A2A2A] font-semibold mb-4">5. Google Fonts</h2>
            <div className="bg-white border border-[#EDE8E0] p-6 text-[#2A2A2A]/65">
              <p>
                Wir verwenden auf unserer Website Google Fonts. Dabei werden beim Aufruf der Seite die verwendeten Schriften von Google-Servern geladen. Dies kann dazu führen, dass Ihre IP-Adresse an Google LLC in den USA übertragen wird. Weitere Informationen finden Sie in der{' '}
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-[#8B7355] hover:underline">
                  Datenschutzerklärung von Google
                </a>.
              </p>
            </div>
          </section>

          <section>
            <h2 className="font-cormorant text-2xl text-[#2A2A2A] font-semibold mb-4">6. OpenStreetMap</h2>
            <div className="bg-white border border-[#EDE8E0] p-6 text-[#2A2A2A]/65">
              <p>
                Auf dieser Website binden wir Kartenmaterial des Dienstes OpenStreetMap ein. Beim Aufruf der Seite mit Karteneinbindung werden Verbindungsdaten (inkl. IP-Adresse) an die Server der OpenStreetMap Foundation übermittelt. Weitere Informationen finden Sie unter{' '}
                <a href="https://wiki.osmfoundation.org/wiki/Privacy_Policy" target="_blank" rel="noopener noreferrer" className="text-[#8B7355] hover:underline">
                  openstreetmap.org
                </a>.
              </p>
            </div>
          </section>

          <section>
            <h2 className="font-cormorant text-2xl text-[#2A2A2A] font-semibold mb-4">7. Ihre Rechte</h2>
            <div className="bg-white border border-[#EDE8E0] p-6 text-[#2A2A2A]/65 space-y-3">
              <p>Sie haben das Recht auf:</p>
              <ul className="list-disc list-inside space-y-1 ml-2">
                <li>Auskunft über Ihre bei uns gespeicherten personenbezogenen Daten (Art. 15 DSGVO)</li>
                <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
                <li>Löschung Ihrer gespeicherten Daten (Art. 17 DSGVO)</li>
                <li>Einschränkung der Datenverarbeitung (Art. 18 DSGVO)</li>
                <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
                <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
              </ul>
              <p>
                Zur Ausübung dieser Rechte wenden Sie sich bitte an:{' '}
                <a href="mailto:gardinenatelier@ausheiligensee.de" className="text-[#8B7355] hover:underline">
                  gardinenatelier@ausheiligensee.de
                </a>
              </p>
              <p>
                Sie haben zudem das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren. Die zuständige Aufsichtsbehörde für Berlin ist der Berliner Beauftragte für Datenschutz und Informationsfreiheit.
              </p>
            </div>
          </section>

          <section>
            <h2 className="font-cormorant text-2xl text-[#2A2A2A] font-semibold mb-4">8. Aktualität und Änderung dieser Datenschutzerklärung</h2>
            <div className="bg-white border border-[#EDE8E0] p-6 text-[#2A2A2A]/65">
              <p>
                Diese Datenschutzerklärung ist aktuell gültig und hat den Stand Februar 2026. Durch die Weiterentwicklung unserer Website oder aufgrund geänderter gesetzlicher oder behördlicher Vorgaben kann es notwendig werden, diese Datenschutzerklärung zu ändern.
              </p>
            </div>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-[#EDE8E0]">
          <a href="/" className="font-outfit text-sm text-[#8B7355] hover:text-[#6B5440] transition-colors flex items-center gap-2">
            ← Zurück zur Startseite
          </a>
        </div>
      </motion.div>
    </main>
    <Footer />
  </div>
);

export default DatenschutzPage;
